<template>
  <v-container>
    <v-layout class="title-section">
      Administrador
    </v-layout>
    <v-flex d-inline-flex>
      <v-flex>
        <v-btn
          class="text-capitalize"
          color="#466EA5"
          dark
          :input-value="activeSection === 0"
          active-class="elevation-0 active-menu-btn"
          @click="activeSection = 0"
        >
          <font-awesome-icon
            class="mr-2"
            :style="{ color: '#FFFFFF' }"
            size="lg"
            :icon="['fal', 'user-plus']"
          />
          Crear Usuario
        </v-btn>
      </v-flex>
      <v-flex>
        <v-btn
          class="text-capitalize"
          color="#466EA5"
          dark
          :input-value="activeSection === 1"
          active-class="elevation-0 active-menu-btn"
          @click="activeSection = 1"
        >
          <font-awesome-icon
            class="mr-2"
            :style="{ color: '#FFFFFF' }"
            size="lg"
            :icon="['fal', 'users']"
          />
          Lista de Usuarios
        </v-btn>
      </v-flex>
      <v-flex>
        <v-btn
          class="text-capitalize"
          color="#466EA5"
          dark
          :input-value="activeSection === 2"
          active-class="elevation-0 active-menu-btn"
          @click="activeSection = 2"
        >
          <font-awesome-icon
            class="mr-2"
            :style="{ color: '#FFFFFF' }"
            size="lg"
            :icon="['fal', 'ticket']"
          />
          Service Tickets
        </v-btn>
      </v-flex>
    </v-flex>
    <v-divider class="mt-2 mb-3"></v-divider>
    <v-flex v-if="activeSection === 0" d-flex>
      <users />
    </v-flex>
    <v-flex v-else-if="activeSection === 1">
      <users-table />
    </v-flex>
    <v-flex v-else-if="activeSection === 2">
      <service-tickets />
    </v-flex>
  </v-container>
</template>

<script>
import Users from "../components/Users";
import UsersTable from "../components/UsersTable";
import ServiceTickets from "../components/ServiceTickets";

export default {
  components: {
    Users,
    UsersTable,
    ServiceTickets
  },
  data() {
    return {
      activeSection: 0
    };
  }
};
</script>

<style lang="stylus" scoped>
.active-menu-btn
  opacity 0.5

.title-section
  font-size 40px
  font-weight 700
  color #C46D24
</style>
